<ion-header id="header">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="close()">Cancel<ion-icon slot="start" name="close-circle-outline"></ion-icon></ion-button>
    </ion-buttons>

    <ion-buttons slot="end">
      <ion-button (click)="confirm()" [disabled]="!selectedProperties.length">
        Next<ion-icon slot="end" name="arrow-forward-circle-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>Phone & Emails</ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      placeholder="Property Address"
      (ionInput)="filterProperties($event)"
      (ionClear)="clearFilterProperties()"
      [debounce]="100"
    ></ion-searchbar>
  </ion-toolbar>
  <ion-toolbar>
    <ion-label slot="end" class="tw:ml-4">
      <b>{{ selectedProperties.length }}</b> Selected
    </ion-label>
    <ion-toggle
      slot="start"
      class="tw:mr-3"
      labelPlacement="end"
      [checked]="isEntireFarmSelected"
      (ionChange)="toggleEntireFarm()"
    >
      Entire Farm
    </ion-toggle>
  </ion-toolbar>
</ion-header>

<ion-content color="light">
  @let filteredProperties = properties | redFilterWalkingFarmProperties: filterText;
  <cdk-virtual-scroll-viewport
    itemSize="66.5"
    minBufferPx="665"
    maxBufferPx="1330"
    class="ion-content-scroll-host tw:h-full tw:w-full"
  >
    <ion-list [inset]="false" lines="full" class="no-last-line">
      <ng-container *cdkVirtualFor="let property of filteredProperties; trackBy: propertiesListTrackBy">
        <ion-item class="tw:max-w-full">
          <ion-checkbox
            class="tw:w-full"
            justify="start"
            (ionChange)="toggleProperty(property.A000_PropertyNumber)"
            [checked]="property.phoneAndEmailIsSelected"
            labelPlacement="end"
            [helperText]="property | redAddress: addressEnum.LineTwo"
          >
            <p class="tw:mr-2 tw:truncate">
              {{ property | redAddress: addressEnum.LineOne }}
            </p>
          </ion-checkbox>
          @if (property.phoneAndEmailIsPurchased) {
            <ion-icon slot="end" name="cart" color="success"></ion-icon>
          }
        </ion-item>
      </ng-container>
    </ion-list>
    @if (!filteredProperties.length) {
      <div class="tw:m-4 tw:text-xs">
        <ion-note color="medium">No properties match your filtered text. Please type something else.</ion-note>
      </div>
    }
  </cdk-virtual-scroll-viewport>
</ion-content>
